<template>
    <InfoModal v-model:open="open" :title="t('journeys.nadiaSuggestionsInfoModal.title')" :sections="sections" />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import InfoModal, { type InfoModalSection } from "./InfoModal.vue";

const open = defineModel<boolean>("open", { default: false });

const { t } = useI18n();

// Locale catalogue can finish loading after mount, so section copy must stay reactive to the active locale.
const sections = computed<InfoModalSection[]>(() => [
    {
        icon: "bi-chat-quote",
        title: t("journeys.nadiaSuggestionsInfoModal.sections.chat.title"),
        description: t("journeys.nadiaSuggestionsInfoModal.sections.chat.description"),
    },
    {
        icon: "bi-arrow-repeat",
        title: t("journeys.nadiaSuggestionsInfoModal.sections.review.title"),
        description: t("journeys.nadiaSuggestionsInfoModal.sections.review.description"),
    },
]);
</script>
